import { render } from "./DeclaracoesDocumentos.vue?vue&type=template&id=adfbdba0&scoped=true"
import script from "./DeclaracoesDocumentos.vue?vue&type=script&lang=js"
export * from "./DeclaracoesDocumentos.vue?vue&type=script&lang=js"

import "./DeclaracoesDocumentos.vue?vue&type=style&index=0&id=adfbdba0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adfbdba0"]])

export default __exports__